export const AUTH_FORM_TEXT = "Войдите или зарегистрируйтесь, чтобы увидеть контакты продавца";
export const CONTACT_TEXT = {
    SHOW_PHONE: "Показать телефон",
    PHONE_UNKNOWN: "Номер неизвестен"
};
export const CONTACT_TIMEOUT = 1000;